import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setBreadcrumb } from 'components/Navbar/modules';
import { resetAll } from 'modules/steps/actions';
import { getSerendipityAction } from 'modules/serendipity/actions';
import NoRecommendations from '../components';


function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.recommendations || {},
    app: state.app,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),
    getSerendipityAction: bindActionCreators(getSerendipityAction, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NoRecommendations));



// WEBPACK FOOTER //
// ./src/routes/RecommendationsUsers/container/index.js